var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditCustomer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.319,
    height: 14.089,
    viewBox: "0 0 12.319 14.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363a4a",
    d: "M305.836,4.89l2.1-2.114L305.176,0l-2.1,2.114Z",
    transform: "translate(-295.62 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363a4a",
    d: "M32.812,325.291l-.648.651v2.774h2.765l.647-.649Z",
    transform: "translate(-32.164 -316.343)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363a4a",
    d: "M88.272,114.15l5.181-5.2-2.764-2.776-5.181,5.2Z",
    transform: "translate(-84.041 -103.249)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.264)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363a4a",
    d: "M32.164,482.193H44.483v.825H32.164Z",
    transform: "translate(-32.164 -482.193)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.658 11.548)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363a4a",
    d: "M237.864,419.821h6.661v.825h-6.661Z",
    transform: "translate(-237.864 -419.821)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCustomer);
export default __webpack_public_path__ + "static/media/editCustomer.d0950bf29fc25e9dec2c3d1b14cf4831.svg";
export { ForwardRef as ReactComponent };